module.exports = __webpack_public_path__ + "img/bg_bus.68f00d06.jpg";